import { z } from "zod";

/**
 * Mobula API response for token trade by transaction hash
 * @see https://api.mobula.io/api/2/token/trade
 */

/**
 * Token info from Mobula trade response
 */
export const mobulaTradeTokenSchema = z.object({
  address: z.string(),
  chainId: z.string().optional(),
  symbol: z.string(),
  name: z.string().optional(),
  decimals: z.number().optional(),
});

export type MobulaTradeToken = z.infer<typeof mobulaTradeTokenSchema>;

export const mobulaTradeDataSchema = z.object({
  id: z.string(),
  operation: z.string(),
  type: z.enum(["buy", "sell", "deposit", "withdrawal"]),
  baseTokenAmount: z.number(),
  baseTokenAmountRaw: z.string(),
  baseTokenAmountUSD: z.number(),
  quoteTokenAmount: z.number(),
  quoteTokenAmountRaw: z.string(),
  quoteTokenAmountUSD: z.number(),
  date: z.number(), // Unix timestamp in milliseconds
  swapSenderAddress: z.string(),
  transactionSenderAddress: z.string(),
  blockchain: z.string(),
  transactionHash: z.string(),
  marketAddress: z.string(),
  baseTokenPriceUSD: z.number(),
  quoteTokenPriceUSD: z.number(),
  labels: z.array(z.string()).optional(),
  baseToken: mobulaTradeTokenSchema,
  quoteToken: mobulaTradeTokenSchema,
});

export type MobulaTradeData = z.infer<typeof mobulaTradeDataSchema>;

export const mobulaTransactionResponseSchema = z.object({
  data: mobulaTradeDataSchema,
});

export type MobulaTransactionResponse = z.infer<typeof mobulaTransactionResponseSchema>;
